(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-seo-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!window.pestanasSeoProductoIniciadas) {
    window.pestanasSeoProductoIniciadas = true;

    const activarPestanaSeoProducto = (pestana, enfocar) => {
      const seccion = pestana.closest('[data-product-seo-tabs]');
      const pestanas = Array.from(seccion.querySelectorAll('[data-product-seo-tab]'));
      const paneles = pestanas.map((elemento) => document.getElementById(elemento.getAttribute('aria-controls')));

      const actualizarPestana = () => {
        pestanas.forEach((elemento, indice) => {
          const estaActiva = elemento === pestana;
          elemento.classList.toggle('is-active', estaActiva);
          elemento.setAttribute('aria-selected', estaActiva.toString());
          elemento.tabIndex = estaActiva ? 0 : -1;
          if (paneles[indice]) {
            paneles[indice].hidden = !estaActiva;
          }
        });

        if (enfocar) pestana.focus();
      };

      if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        document.startViewTransition(actualizarPestana);
      } else {
        actualizarPestana();
      }
    };

    document.addEventListener('click', (evento) => {
      const pestana = evento.target.closest('[data-product-seo-tab]');
      if (pestana) activarPestanaSeoProducto(pestana, false);
    });

    document.addEventListener('keydown', (evento) => {
      const pestana = evento.target.closest('[data-product-seo-tab]');
      if (!pestana) return;

      const pestanas = Array.from(pestana.closest('[role="tablist"]').querySelectorAll('[data-product-seo-tab]'));
      if (pestanas.length <= 1) return;
      const indiceActual = pestanas.indexOf(pestana);
      let indiceSiguiente = indiceActual;

      if (evento.key === 'ArrowRight') indiceSiguiente = (indiceActual + 1) % pestanas.length;
      if (evento.key === 'ArrowLeft') indiceSiguiente = (indiceActual - 1 + pestanas.length) % pestanas.length;
      if (evento.key === 'Home') indiceSiguiente = 0;
      if (evento.key === 'End') indiceSiguiente = pestanas.length - 1;
      if (indiceSiguiente === indiceActual) return;

      evento.preventDefault();
      activarPestanaSeoProducto(pestanas[indiceSiguiente], true);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reborn-collections-grid"] && !Shopify.designMode) return;
  try {
    
function initCollectionsCarousels() {
  var carousels = document.querySelectorAll('[data-rbr26-cols-carousel]');
  carousels.forEach(function (wrapper) {
    if (wrapper.dataset.colsCarouselReady === 'true') return;

    var grid = wrapper.querySelector('[data-rbr26-cols-track]');
    var prevBtn = wrapper.querySelector('[data-rbr26-cols-prev]');
    var nextBtn = wrapper.querySelector('[data-rbr26-cols-next]');

    if (!grid) return;

    var autoplayEnabled = wrapper.dataset.autoplay === 'true';
    var intervalSec = parseInt(wrapper.dataset.interval, 10) || 4;
    var autoplayTimer = null;

    function getScrollStep() {
      var item = grid.querySelector('.rbr26-cols-item');
      if (!item) return 300;
      var style = window.getComputedStyle(grid);
      var gap = parseFloat(style.gap) || 0;
      return item.offsetWidth + gap;
    }

    function updateNavState() {
      if (!prevBtn || !nextBtn) return;
      var maxScroll = grid.scrollWidth - grid.clientWidth;
      if (maxScroll <= 5) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
      } else {
        prevBtn.style.display = 'inline-flex';
        nextBtn.style.display = 'inline-flex';
        prevBtn.disabled = grid.scrollLeft <= 5;
        nextBtn.disabled = grid.scrollLeft >= maxScroll - 5;
      }
    }

    function scrollNext() {
      var maxScroll = grid.scrollWidth - grid.clientWidth;
      if (maxScroll <= 5) return;
      if (grid.scrollLeft >= maxScroll - 10) {
        grid.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        grid.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
      }
    }

    function scrollPrev() {
      var maxScroll = grid.scrollWidth - grid.clientWidth;
      if (maxScroll <= 5) return;
      if (grid.scrollLeft <= 10) {
        grid.scrollTo({ left: maxScroll, behavior: 'smooth' });
      } else {
        grid.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
      }
    }

    function startAutoplay() {
      if (!autoplayEnabled) return;
      stopAutoplay();
      autoplayTimer = setInterval(function () {
        scrollNext();
      }, intervalSec * 1000);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        stopAutoplay();
        scrollPrev();
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        stopAutoplay();
        scrollNext();
        startAutoplay();
      });
    }

    grid.addEventListener('scroll', function () {
      updateNavState();
    }, { passive: true });

    window.addEventListener('resize', function () {
      updateNavState();
    }, { passive: true });

    wrapper.addEventListener('mouseenter', stopAutoplay);
    wrapper.addEventListener('mouseleave', startAutoplay);
    wrapper.addEventListener('touchstart', stopAutoplay, { passive: true });
    wrapper.addEventListener('touchend', function () {
      setTimeout(startAutoplay, 1500);
    }, { passive: true });

    wrapper.dataset.colsCarouselReady = 'true';
    updateNavState();
    startAutoplay();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionsCarousels);
} else {
  initCollectionsCarousels();
}

document.addEventListener('shopify:section:load', function () {
  initCollectionsCarousels();
});

document.addEventListener('shopify:block:select', function (e) {
  var blockId = e.detail && e.detail.blockId;
  if (!blockId) return;
  var targetItem = document.querySelector('[data-block-id="' + blockId + '"]');
  if (targetItem && typeof targetItem.scrollIntoView === 'function') {
    targetItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reborn-hero"] && !Shopify.designMode) return;
  try {
    
function initHeroSliders() {
  var sliders = document.querySelectorAll('[data-rbr26-hero-slider]');
  sliders.forEach(function (slider) {
    if (slider.dataset.sliderReady === 'true') return;

    var track = slider.querySelector('[data-rbr26-hero-track]');
    var originalSlides = Array.prototype.slice.call(slider.querySelectorAll('[data-rbr26-hero-slide]'));
    var dots = slider.querySelectorAll('[data-rbr26-dot]');
    var prevBtn = slider.querySelector('[data-rbr26-prev]');
    var nextBtn = slider.querySelector('[data-rbr26-next]');
    var totalCount = originalSlides.length;

    if (!track || totalCount <= 1) {
      slider.dataset.sliderReady = 'true';
      return;
    }

    var firstClone = originalSlides[0].cloneNode(true);
    var lastClone = originalSlides[totalCount - 1].cloneNode(true);
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.setAttribute('aria-hidden', 'true');
    var firstCloneLink = firstClone.querySelector('a');
    if (firstCloneLink) firstCloneLink.setAttribute('tabindex', '-1');
    var lastCloneLink = lastClone.querySelector('a');
    if (lastCloneLink) lastCloneLink.setAttribute('tabindex', '-1');

    track.insertBefore(lastClone, originalSlides[0]);
    track.appendChild(firstClone);

    var currentIndex = 1;
    var isTransitioning = false;
    var intervalSec = parseInt(slider.dataset.interval, 10) || 4;
    var timer = null;
    var isPaused = false;

    track.style.transition = 'none';
    track.style.transform = 'translateX(-100%)';
    void track.offsetWidth;
    track.style.transition = '';

    function updateDots(activeIdx) {
      dots.forEach(function (dot, i) {
        var isActive = i === activeIdx;
        dot.classList.toggle('is-active', isActive);
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function moveTo(index, smooth) {
      if (smooth === false) {
        track.style.transition = 'none';
      } else {
        track.style.transition = 'transform 0.65s cubic-bezier(0.25, 1, 0.5, 1)';
      }
      currentIndex = index;
      track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';

      var realIndex = (currentIndex - 1 + totalCount) % totalCount;
      updateDots(realIndex);
    }

    function next() {
      if (isTransitioning) return;
      isTransitioning = true;
      moveTo(currentIndex + 1, true);
    }

    function prev() {
      if (isTransitioning) return;
      isTransitioning = true;
      moveTo(currentIndex - 1, true);
    }

    track.addEventListener('transitionend', function () {
      isTransitioning = false;
      if (currentIndex === totalCount + 1) {
        moveTo(1, false);
        void track.offsetWidth;
        track.style.transition = '';
      } else if (currentIndex === 0) {
        moveTo(totalCount, false);
        void track.offsetWidth;
        track.style.transition = '';
      }
    });

    function startTimer() {
      stopTimer();
      if (intervalSec > 0 && !isPaused) {
        timer = setInterval(function () {
          next();
        }, intervalSec * 1000);
      }
    }

    function stopTimer() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    slider.addEventListener('mouseenter', function () {
      isPaused = true;
      stopTimer();
    });

    slider.addEventListener('mouseleave', function () {
      isPaused = false;
      startTimer();
    });

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        next();
        startTimer();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        prev();
        startTimer();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var targetDot = parseInt(dot.dataset.index, 10);
        if (!isNaN(targetDot)) {
          isTransitioning = true;
          moveTo(targetDot + 1, true);
          startTimer();
        }
      });
    });

    var touchStartX = 0;
    var touchEndX = 0;
    slider.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
      stopTimer();
    }, { passive: true });

    slider.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 40) {
        if (diff > 0) {
          next();
        } else {
          prev();
        }
      }
      startTimer();
    }, { passive: true });

    slider.dataset.sliderReady = 'true';
    slider._moveToBlock = function (blockId) {
      for (var i = 0; i < originalSlides.length; i++) {
        if (originalSlides[i].dataset.blockId === blockId) {
          isTransitioning = false;
          moveTo(i + 1, true);
          stopTimer();
          break;
        }
      }
    };

    startTimer();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeroSliders);
} else {
  initHeroSliders();
}

document.addEventListener('shopify:section:load', function () {
  initHeroSliders();
});

document.addEventListener('shopify:block:select', function (e) {
  var blockId = e.detail && e.detail.blockId;
  if (!blockId) return;
  var sliders = document.querySelectorAll('[data-rbr26-hero-slider]');
  sliders.forEach(function (slider) {
    if (typeof slider._moveToBlock === 'function') {
      slider._moveToBlock(blockId);
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reborn-product-tabs"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-rbr26-tabs]').forEach(function (root) {
  var buttons = Array.prototype.slice.call(root.querySelectorAll('.rbr26-tab-btn'));
  function activate(button) {
    var swap = function () {
      buttons.forEach(function (other) {
        var panel = document.getElementById(other.getAttribute('data-rbr26-tab'));
        var active = other === button;
        other.classList.toggle('rbr26-tab-btn--active', active);
        other.setAttribute('aria-selected', active ? 'true' : 'false');
        if (panel) {
          panel.hidden = !active;
        }
      });
    };
    if (document.startViewTransition) {
      document.startViewTransition(swap);
    } else {
      swap();
    }
  }
  buttons.forEach(function (button, index) {
    button.addEventListener('click', function () {
      activate(button);
    });
    button.addEventListener('keydown', function (event) {
      var next = null;
      if (event.key === 'ArrowRight') {
        next = buttons[(index + 1) % buttons.length];
      }
      if (event.key === 'ArrowLeft') {
        next = buttons[(index - 1 + buttons.length) % buttons.length];
      }
      if (next) {
        event.preventDefault();
        next.focus();
        activate(next);
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
